export const state = (state) => {
  return state;
};

// export const lessons = (state) => {
//   let lessons = state.learnLessons.map((row) => {
//     return [...row.withoutShift, ...row.withShift];
//   }).flat();
//   return lessons; //state.lessons;
// };
